import { HttpErrorResponse } from '@angular/common/http';
import { BackendErrorResponse } from '@zero/shared/util-models';

export const getErrorMessage = (errorResponse: unknown, defaultMessage?: string): string =>
  getMessageFromError(getBackendErrorFromHttpError(errorResponse), defaultMessage);

type StoreError = { error: HttpErrorResponse; type: string };

const getBackendErrorFromHttpError = (ex: unknown): BackendErrorResponse => {
  let httpError = ex as HttpErrorResponse;
  if (!httpError?.status) {
    httpError = (ex as StoreError)?.error;
    if (!httpError?.status) {
      console.error('Store Error', ex);
      return {} as BackendErrorResponse;
    }
  }

  const { status, error, message } = httpError;
  switch (status) {
    case 401:
    case 403:
      return {
        message: 'global-error-messages.logged-out',
        status: status.toString(),
        errors: [error],
      } as BackendErrorResponse;
    case 503:
      return {
        message,
        status: status.toString(),
        errors: [error],
      } as BackendErrorResponse;
    default:
      if (typeof error === 'string') {
        try {
          return JSON.parse(error) as BackendErrorResponse;
        } catch {
          return {
            message: undefined,
            status: status.toString(),
            errors: [error],
          } as BackendErrorResponse;
        }
      } else {
        return error as BackendErrorResponse;
      }
  }
};

const getMessageFromError = (err: BackendErrorResponse, defaultMessage?: string): string =>
  err?.message ?? defaultMessage ?? 'global-error-messages.general';
